import { useState, useEffect, useCallback } from 'react';
import { ExtensionConfig, AdConfig } from '../types/extension';
import { getConfig } from '../config';

export const useExtensions = () => {
    const [config, setConfig] = useState<ExtensionConfig | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/extension.json')
            .then(res => res.json())
            .then(data => {
                setConfig(data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Failed to load extension.json", err);
                setLoading(false);
            });
    }, []);

    const getAdsForPlacement = useCallback((placement: string): { fixed: AdConfig[], loop: AdConfig[], interval: number } => {
        if (!config || !config.ads) return { fixed: [], loop: [], interval: 12 };

        const [provider, section] = placement.split('.');
        // @ts-ignore
        const adsSection = config.ads[provider];
        // @ts-ignore
        const adsList: AdConfig[] = adsSection?.[section] || [];

        const interval = getConfig().gridInterval || 12;

        if (adsList.length === 0) return { fixed: [], loop: [], interval };

        const fixedAds: AdConfig[] = [];
        const loopAds: AdConfig[] = [];

        // Group by priority
        const groupedByPriority: Record<number, AdConfig[]> = {};

        adsList.forEach(ad => {
            const p = ad.priority || 999;
            if (!groupedByPriority[p]) groupedByPriority[p] = [];

            // Expand count
            const count = ad.count !== undefined ? ad.count : 1;
            for (let i = 0; i < count; i++) {
                groupedByPriority[p].push(ad);
            }
        });

        // Sort priorities
        const priorities = Object.keys(groupedByPriority).map(Number).sort((a, b) => a - b);

        priorities.forEach(p => {
            const group = groupedByPriority[p];
            // Shuffle group
            for (let i = group.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [group[i], group[j]] = [group[j], group[i]];
            }

            if (p <= 2) {
                // Priority 1 and 2 are always fixed (one-time)
                fixedAds.push(...group);
            } else {
                // Others are loopable
                loopAds.push(...group);
            }
        });

        return { fixed: fixedAds, loop: loopAds, interval };
    }, [config]);

    return { config, loading, getAdsForPlacement };
};
